import Media from "./media/teacher"
import Signal from "./signal/index"
// import Log from "./util/log"
// import axios from "axios"
// import { getSensorConfig } from "./util/getSensorConfig"
import sensorLog from "@/utils/sensorLog"
import pubsubEvent from "./util/event"
export const centerEventBus = pubsubEvent
export class OCFE {
  constructor() {
    // if (!this.logger) {
    //   this.logger = new Log()
    // }
    sensorLog.initSensor()
  }
  initMedia() {
    return (this.media = new Media())
  }
  initSignal(authInfo, version = "v1") {
    return (this.signal = new Signal())
  }
}
